import { DefaultOptionType } from 'antd/es/select'
import { t } from 'i18next'
import { BudgetingScenario } from '../types/BudgetingScenario'
import { ReportDataType } from '../../../redux/context/reports/types'

export const defaultOptionsSelector = (data: BudgetingScenario[]): DefaultOptionType[] =>
  data.map(scenario => ({ label: scenario.name, value: scenario.id }))

export const createLockedScenariosOptionsSelector =
  (disableLocked = false) =>
  (data: BudgetingScenario[]): DefaultOptionType[] => {
    const budgets = data.filter(scenario => !scenario.forecastType)
    const forecasts = data.filter(scenario => scenario.forecastType)

    const mapScenario = (scenario: BudgetingScenario): DefaultOptionType => ({
      label: scenario.name,
      value: scenario.id,
      isLocked: scenario.isLocked,
      forecastCursor: scenario.forecastCursor,
      ...(disableLocked && { disabled: scenario.isLocked })
    })

    const groups: DefaultOptionType[] = []

    if (budgets.length > 0) {
      groups.push({
        label: t('entity:budgetingScenario'),
        title: ReportDataType.budget,
        options: budgets.map(mapScenario)
      })
    }

    if (forecasts.length > 0) {
      groups.push({
        label: t('entity:forecast'),
        title: ReportDataType.forecast,
        options: forecasts.map(mapScenario)
      })
    }

    return groups
  }

export const groupedOptionsSelector = (data: BudgetingScenario[]): DefaultOptionType[] => {
  const budgets = data.filter(scenario => !scenario.forecastType)
  const forecasts = data.filter(scenario => scenario.forecastType)

  const groups: DefaultOptionType[] = []

  if (budgets.length > 0) {
    groups.push({
      label: t('entity:budgetingScenario'),
      title: ReportDataType.budget,
      options: budgets.map(scenario => ({ label: scenario.name, value: scenario.id }))
    })
  }

  if (forecasts.length > 0) {
    groups.push({
      label: t('entity:forecast'),
      title: ReportDataType.forecast,
      options: forecasts.map(scenario => ({ label: scenario.name, value: scenario.id }))
    })
  }

  return groups
}
